export const STORY_ARCHIVE = "STORY_ARCHIVE";
export const STORIES_FETCH = "STORIES_FETCH";
export const STORIES_FETCH_ERROR = "STORIES_FETCH_ERROR";
export const STORIES_ADD = "STORIES_ADD";
